
import {Component, Vue, Prop, Watch, PropSync} from 'vue-property-decorator';
import {mask} from 'vue-the-mask';
import GStatic from '@/Services/GStatic';



@Component({
  components: {},
  directives: {mask},
})
export default class DialogComponent extends Vue {
  @Prop({default: false})
  public watchToFire: boolean = false;

  @Prop({default: 1})
  public step: string = '';

  @Prop({default: null})
  public otpTimeOut: Date | null = null;

  public otpDeltaTime: string = '';

  @Prop({default: ''})
  public otpErrorMessage: string = '';

  @Prop({default: ''})
  public wrongOtpMessage: string = '';

  @PropSync('MortgagesDetails', {default: {}})
  public syncedMortgagesDetails!: any;

  public form: any = {};
   public formIsValid: any;
  public errors: any = {};

  @PropSync('show', {default: false})
  public showSynced!: any;
  public openDialog: boolean = false;

  public otpCode: string = '';

  public timeInterval: any = {};

   
  // Methods

  @Watch('watchToFire')
  public onPropertyChanged(value: string, oldValue: string) {
    GStatic.log('watchToFire', value, oldValue);
    clearInterval(this.timeInterval);
    this.openDialog = true;

  }

  @Watch('otpTimeOut')
  public onFormPropertyChanged(value: any, oldValue: any) {
    GStatic.log('formInput', value, oldValue);
    clearInterval(this.timeInterval);
    if (value) {
      this.timer();
    }

  }


  public submit(): any {


    if (this.step === 'ApproveMortgages') {
        this.$emit('actionClicked', { step: 'ApproveMortgages'});

    } else if (this.step === 'ApproveMortgages_Otp') {
      if (this.otpCode) {

          this.$emit('actionClicked', { step: 'ApproveMortgages_Otp', otpCode: this.otpCode});
      }
    } else if (this.step === 'CancelRequest') {
        if (this.otpCode) {

            this.$emit('actionClicked', { step: 'CancelMortgages_Otp', otpCode: this.otpCode });
      }
    }
    else {
      this.$emit('actionClicked', {step: this.step});

      this.openDialog = false;
    }

  }

  public cancel(): any {

    this.openDialog = false;
    this.resetComponent();
    this.$emit('actionClicked', {step: 'cancel'});

  }

  public resetComponent() {
    this.step = '';
    this.otpTimeOut = null;
    this.otpDeltaTime = '';
    this.otpErrorMessage = '';
    this.wrongOtpMessage = '';
      this.syncedMortgagesDetails = '';
    this.form = {};
    this.errors = {};
    this.openDialog = false;
    this.otpCode = '';

    clearInterval(this.timeInterval);

  }

  private timer() {
    const countDownDate = this.otpTimeOut ? this.otpTimeOut.getTime() : -1;
    if (countDownDate > 0) {
      this.timeInterval = setInterval(() => {
        const distance = countDownDate - new Date().getTime();
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          this.otpDeltaTime = this.$t('mortgages.view.dialog.ApproveMortgages_Otp.time', [minutes, seconds]).toString();
        if (distance < 0) {
          clearInterval(this.timeInterval);
          this.otpDeltaTime = '0';
        }
      }, 1000);
    }
  }
}
